// Data pro Burger Rock Fest Napajedla

export const festivalInfo = {
  name: "BURGER ROCK FEST",
  subtitle: "NAPAJEDLA",
  date: "6. června 2026",
  time: "15:00–23:00",
  location: "Nádvoří Nového Kláštera Napajedla",
  expectedVisitors: "1 500",
  entrance: "VSTUPNÉ ZDARMA",
  eventId: "burger-rock-fest-2026",
  edition: "11. ročník tradiční akce",
};

export const programSchedule = {
  friday: {
    day: "Pátek 6. 6. 2026",
    time: "15:00–23:00",
    description: "Burgery, rock a skvělá atmosféra",
  },
};

export const programHighlights = [
  "🎸 44 v klidu (KM)",
  "🎸 Street crew (NAPA)",
  "🎸 Waťák – Kabát revival",
  "🍔 Soutěž v pojídání burgerů",
  "🍺 Pivní soutěže",
  "🎪 Chill zóna",
  "👶 Dětské atrakce",
];

export const whyJoinReasons = [
  {
    title: "Rock & Burgery",
    description: "Jedinečná kombinace skvělé muziky a nejlepších burgerů. 11. ročník tradiční akce s rockovou atmosférou.",
    icon: "Music",
  },
  {
    title: "Skvělá návštěvnost",
    description: "Očekávaná návštěvnost 1500 osob. Tradiční akce s věrným publikem, které rádo utrácí za dobré jídlo.",
    icon: "Users",
  },
  {
    title: "Dlouhá otevírací doba",
    description: "Akce trvá od 15:00 do 23:00 (8 hodin). Večerní atmosféra zajišťuje vysokou spotřebu jídla i nápojů.",
    icon: "Clock",
  },
  {
    title: "Historická lokace",
    description: "Nádvoří Nového Kláštera v Napajedlích vytváří jedinečnou atmosféru pro rock festival s burgery.",
    icon: "MapPin",
  },
  {
    title: "Vstup zdarma",
    description: "Festival s volným vstupem přitahuje široké publikum. Žádná vstupní bariéra = více návštěvníků = vyšší tržby.",
    icon: "Ticket",
  },
  {
    title: "Tradiční akce",
    description: "11. ročník znamená osvědčený koncept a věrné publikum, které se vrací rok co rok.",
    icon: "Star",
  },
];

export const vendorCategories = {
  priority: {
    title: "PRIORITA: Prodejci burgerů a food trucky",
    description: "Hledáme především prodejce burgerů a kvalitních food trucků s rychlým občerstvením.",
    requirements: [
      "Burgery všeho druhu (klasické, gourmet, vege)",
      "Food trucky s masem a grilovanými specialitami",
      "Rychlé občerstvení vhodné k pivu",
      "Zkušenosti z večerních akcí a festivalů",
    ],
  },
  desserts: {
    title: "Dezerty a teplé nápoje",
    description: "Omezený počet míst pro dezerty a kávu",
    categories: [
      "Káva a kávové speciality",
      "Sladké dezerty",
      "Zmrzlina",
      "Palačinky a waffle",
    ],
  },
  additional: {
    title: "Drobní prodejci",
    description: "Doplňkový sortiment",
    categories: [
      "Hračky pro děti",
      "Koření a omáčky",
      "Handmade výrobky",
      "Rockový merch",
    ],
  },
};

export const importantRules = [
  {
    title: "Zákaz prodeje nápojů",
    description: "Alkoholické i nealkoholické nápoje zajišťuje výhradně pořadatel.",
    note: "Výjimky pouze po předchozí domluvě s pořadatelem.",
    icon: "XCircle",
  },
  {
    title: "Ceny bez DPH",
    description: "Všechny uvedené ceny jsou bez DPH. DPH bude připočítáno podle platné legislativy.",
    icon: "CreditCard",
  },
];

export const pricingConditions = {
  burgers: {
    title: "HLAVNÍ PRODEJCI",
    size: "max 6x3m",
    category: "Burgery a food trucky",
    price: "6.000 Kč",
  },
  desserts: {
    title: "DEZERTY / TEPLÉ NÁPOJE",
    size: "max 6x3m",
    category: "káva, dezerty",
    price: "3.500 Kč",
  },
  small: {
    title: "DROBNÍ PRODEJCI",
    size: "max 3x3m",
    category: "hračky, koření, drobnosti",
    price: "2.000 Kč",
  },
  electricity: {
    title: "ENERGIE - příkon (MAX 12 KW)",
    options: [
      { range: "DO 3KW", price: "1.750 Kč" },
      { range: "3KW až 6KW", price: "3.300 Kč" },
      { range: "nad 6KW", price: "4.500 Kč" },
    ],
    note: "(celá akce)",
  },
  note: "Ceny jsou uvedeny bez DPH",
};

export const contactInfo = {
  name: "Jakub Vodárek",
  phone: "+420 774 750 456",
  email: "info@vseproakci.cz",
};

export const heroImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/ir296lak_357133158_845481907024881_8971062965906032917_n.jpg";
